import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import json from "./json/en.json"
import config from './config.json'
import './styles/fonts.css';
import './styles/main.css';

const savedTheme = localStorage.getItem('jumbada_theme');
const activeTheme = savedTheme || config.theme;
if (activeTheme === 'light') {
  document.body.classList.add('theme-light');
}

store.dispatch('initAuth');
store.dispatch('loadGames');

// Запрет масштабирования: touch-action в CSS не покрывает Safari-специфичные
// pinch-жесты и Ctrl+колесо на десктопе, а double-tap-zoom иногда проходит
// даже с touch-action — добираем через events.
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('gesturechange', (e) => e.preventDefault());
document.addEventListener('wheel', (e) => {
  if (e.ctrlKey) e.preventDefault();
}, { passive: false });

let lastTouchEnd = 0;
document.addEventListener('touchend', (e) => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    e.preventDefault();
  }
  lastTouchEnd = now;
}, { passive: false });

createApp(App).use(store).use(router).provide('jsonData', json).mount('#app')
